import './Main.css'

import React, { useEffect, useRef, useState } from 'react'
import { useAppContext } from '@/context/app'
import { useForm, UseFormReturn } from 'react-hook-form'
import { addServerErrors } from '@/components/forms/common/FormBase'
import { FormData, QuickCreateUserForm } from './types'
import { WizardData } from './data'
import { useWizard } from '@/common/wizard/wizard'
import { Spinner } from '@/components/spinner'

export const CreateUserWizardStep2 = ({ onDone }: {
  onDone: (data: WizardData, form: UseFormReturn<FormData, any, undefined>) => Promise<void>
}) => {
  const { services, session, translates } = useAppContext()
  const { wizardData, updateWizardData, nextStep, prevStep } = useWizard<WizardData>()
  const form = useForm<FormData>({
    defaultValues: wizardData as any
  })

  const handle = (data: FormData): Promise<void> => {
    return onDone({
      ...wizardData,
      ...data
    }, form)
  }

  if (translates === undefined || wizardData === undefined) {
    return <Spinner />
  }

  return <div>
    <QuickCreateUserForm
      onSubmit={handle}
      services={services}
      form={form}
      translates={translates}
      formName='user'
      readOnly={false}
    />
    <div className='right-btns'>
      <button className='btn btn-next' onClick={() => {
        updateWizardData({
          ...wizardData,
          ...form.getValues()
        })
        prevStep()
      }}>{translates.for('popup.create_user_wizard.prev')}</button>
      <button className='btn btn-next' onClick={() => {
        form.handleSubmit(handle)()
      }}>{translates.for('popup.create_user_wizard.accept')}</button>
    </div>
  </div>
}

